import { getAuth, connectAuthEmulator } from "firebase/auth";
// import firebase from "firebase"
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import config from "../constants/configs";

const firebaseConfig = config.firebaseConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const db = getFirestore(app);
if (process.env.REACT_APP_EVIRONMENT === "local") {
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
}

export { db };

export const auth = getAuth(app);
if (process.env.REACT_APP_EVIRONMENT === "local") connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
